



















export default {
  name: 'About',
  props: ['pageTitle'],
};
